import { render, staticRenderFns } from "./FilterProvince.vue?vue&type=template&id=57c70d7a&"
import script from "./FilterProvince.vue?vue&type=script&lang=js&"
export * from "./FilterProvince.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports